declare global {
  interface Window {
    fbq: any
    _fbq: any
  }
}

const PIXEL_ID = '870739235966399'
const DEFAULT_CHECKOUT_URL =
  'https://www.elplacerquenutre.com//cart/45066643734630:1'

export function initMetaPixel() {
  if (typeof window === 'undefined' || window.fbq) return

  const f = window
  const b = document
  const n: any = (f.fbq = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
  })
  if (!f._fbq) f._fbq = n
  n.push = n
  n.loaded = true
  n.version = '2.0'
  n.queue = []

  const t = b.createElement('script') as HTMLScriptElement
  t.async = true
  t.src = 'https://connect.facebook.net/en_US/fbevents.js'
  b.head.appendChild(t)

  window.fbq('init', PIXEL_ID)
  window.fbq('track', 'PageView')

  // Add noscript image fallback for PageView
  const noscriptImg = b.createElement('img')
  noscriptImg.height = 1
  noscriptImg.width = 1
  noscriptImg.style.display = 'none'
  noscriptImg.src = `https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`
  b.body.appendChild(noscriptImg)
}

export function trackAddToCart(e?: React.MouseEvent) {
  if (e) {
    e.preventDefault()
  }

  // Get the dynamic URL from the clicked link's href, or fall back to default
  const targetUrl =
    e?.currentTarget?.getAttribute('href') || DEFAULT_CHECKOUT_URL

  // Fire via fbq SDK if available
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', 'AddToCart', {
      content_ids: ['44835922083942'],
      content_type: 'product',
      value: 14997.0,
      currency: 'MXN',
    })
  }

  // Fire image pixel as reliable fallback (ensures event is sent even if SDK not fully loaded)
  const pixelUrl = `https://www.facebook.com/tr?id=${PIXEL_ID}&ev=AddToCart&cd[content_ids]=44835922083942&cd[content_type]=product&cd[value]=14997&cd[currency]=MXN&noscript=1`

  // Use sendBeacon for reliability during navigation (won't be cancelled by page unload)
  if (navigator.sendBeacon) {
    navigator.sendBeacon(pixelUrl)
  } else {
    const img = new Image(1, 1)
    img.src = pixelUrl
  }

  // Navigate to the dynamic cart URL after a short delay to let SDK event process
  setTimeout(() => {
    window.location.href = targetUrl
  }, 500)
}
